import React from "react";
import { EntityManagerFileBar } from "./components/EntityFileBar";
import { EntityLocationView } from "../entityViews/location/EntityLocationView";
import { EntityNotesView } from "../entityViews/notes/EntityNotesView";
import { EntityOwnershipView } from "../entityViews/ownership/EntityOwnershipView";
import { EntityContactView } from "../entityViews/contacts/EntityContactView";
import { EntityChecklistView } from "../entityViews/checklist/EntityChecklistView";
import { useEntityManagerContext } from "./context/EntityManagerContext";
import { ENTITY_TYPES } from "@/other/constants/OtherKeys";
import { EntityDescription } from "../entityViews/entityDescription/EntityDescription";
import { MarketingAssetsView } from "../entityViews/marketing/MarketingAssetsView";

export const EntityDashboardView = () => {
  const { entityType, record } = useEntityManagerContext();
  {/* using key to force re-render when record is switched from Entity Finder */ }
  return (
    <div key={`${entityType}-${record.id}`}>
      <EntityManagerFileBar />
      <div className="grid grid-cols-12 @container gap-x-8 gap-y-12 px-6 py-10">
        <div className="col-span-12 @2xl:col-span-6 @5xl:col-span-4">
          <MarketingAssetsView />
        </div>
        {entityType !== ENTITY_TYPES.CLIENT && (
          <div className="col-span-12 @2xl:col-span-6 @5xl:col-span-4">
            <EntityDescription />
          </div>
        )}
        <div className="col-span-12 @2xl:col-span-6 @5xl:col-span-4">
          <EntityNotesView />
        </div>
        <div className="col-span-12 @2xl:col-span-6 @5xl:col-span-4">
          <EntityChecklistView />
        </div>
        {entityType === ENTITY_TYPES.TASK && (
          <div className="col-span-12 @2xl:col-span-6 @5xl:col-span-4">
            <EntityLocationView record={record} />
          </div>
        )}
        <div className="col-span-12 @2xl:col-span-6 @5xl:col-span-4">
          <EntityContactView />
        </div>
        <div className="col-span-12 @2xl:col-span-6 @5xl:col-span-4">
          <EntityOwnershipView />
        </div>
      </div>
    </div>
  );
};
